import React, { useEffect, useState } from "react";
import { isCatalogueResellerSharingEnabled } from "../../helpers/catalogueResellerSharingEnabled";
import { Modal, ModalHeader, ModalBody, Button, Label, Input } from "reactstrap";
import { connect } from "react-redux";
import { connectOrg, updateParty } from "../../Store/organisation/actions";
import ModalCloseIcon from "../../common/Components/Icons/ModalCloseIcon";
import Loader from "../../common/Components/Loader/Loader";
import notifications from "../../common/Components/Notifications/Notification";
import Select from "react-select";
import { AddIcon } from "../../common/Components/Icons/AddIcon";
import AddOrEditOrganisation from "./AddOrEditOrganisation";
var partyOptions: any = [
  {
    label: "Customer",
    value: "Customer",
  },
  {
    label: "Supplier",
    value: "Supplier",
  },
];
var regexpForGst =
  /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Zz][0-9A-Z]{1}$/;
let gstOptionsData: any = [];
const AddParty = (props: any) => {
  let {
    openModal,
    closeModal,
    handleOnInputChangeFilters,
    gstOptions,
    getAllData,
  } = props;
  gstOptionsData = gstOptions;
  const [loading, setLoading]: any = useState(false);

  const [form, setForm]: any = useState({
    partyName: "",
    partyType: "",
  });
  const [Error, setError]: any = useState({
    partyName: "",
    partyType: "",
    organizationName: "",
    phoneEdit: "",
    gstEdit: "",
  });
  const [openModalOrg, setModalOrg]: any = useState(false);
  const [orgName, setOrgName] = useState("");
  const [contactName, setContactName] = useState("");
  const [phoneEdit, setPhoneEdit] = useState("");
  const [gstEdit, setGstEdit] = useState("");
  // Reseller sharing (catalogue): this party may forward RESELLER-mode catalogues to their clients.
  const resellerSharingOn = isCatalogueResellerSharingEnabled();
  const [isReseller, setIsReseller] = useState(false);
  const [forwardLimit, setForwardLimit] = useState("3");
  const [allowDownload, setAllowDownload] = useState(false);

  useEffect(() => {
    if (props.partyDetails?.counterpartyOrganizationId) {
      setOrgName(props.partyDetails?.name || "");
      setContactName(props.partyDetails?.contactPersonName || "");
      setPhoneEdit(props.partyDetails?.phone || "");
      setGstEdit(props.partyDetails?.gst || "");
      setIsReseller(props.partyDetails?.isReseller === true);
      setForwardLimit(String(props.partyDetails?.resellerForwardLimit || 3));
      setAllowDownload(props.partyDetails?.resellerAllowDownload === true);
      setForm((prev: any) => ({
        ...prev,
        partyType: {
          label: props.partyDetails?.partyType,
          value: props.partyDetails?.partyType,
        },
      }));
      return;
    }
    if (props.partyDetails?.id?.length > 0) {
      setForm({
        ...form,
        partyName: {
          label:
            (props.partyDetails?.gst?.length > 0
              ? props.partyDetails?.gst
              : "N/A") +
            "(" +
            props.partyDetails?.name +
            ")" +
            "(" +
            (props.partyDetails?.phone?.length > 0
              ? props.partyDetails?.phone
              : "N/A") +
            ")",
          value: {
            gst: props.partyDetails?.gst,
            phone: props.partyDetails?.phone,
          },
        },
        partyType: {
          label: props.partyDetails?.partyType,
          value: props.partyDetails?.partyType,
        },
      });
    }
  }, [props.partyDetails?.id, props.partyDetails?.counterpartyOrganizationId]);
  const handleChange = (type: any) => {
    setForm({
      ...form,
      [type?.name]: type.value,
    });
  };
  const validate = () => {
    if (props.partyDetails?.counterpartyOrganizationId) {
      let error = "";
      const err: any = {
        partyName: "",
        partyType: "",
        organizationName: "",
        phoneEdit: "",
        gstEdit: "",
      };
      if (!orgName.trim()) {
        error = "Required";
        err.organizationName = "Organization or display name is required.";
      }
      if (!phoneEdit.trim()) {
        error = "Required";
        err.phoneEdit = "Phone is required.";
      }
      if (!form?.partyType?.value) {
        error = "Required";
        err.partyType = "Party Type is Required!";
      }
      const g = gstEdit.trim().toUpperCase();
      if (g && !regexpForGst.test(g)) {
        error = "Invalid GST";
        err.gstEdit = "Enter a valid 15-character GSTIN or leave blank.";
      }
      setError(err);
      return error;
    }
    let error = "";
    let err = Error;
    if (form?.partyName === "") {
      error = "Required";
      err = {
        ...err,
        partyName: "Party Name is Required!",
      };
    }
    if (form?.partyType === "") {
      error = "Required";
      err = {
        ...err,
        partyType: "Party Type is Required!",
      };
    }
    setError(err);
    return error;
  };
  const handleSubmit = () => {
    let result: any = validate();
    if (result?.length === 0) {
      if (props.partyDetails?.id?.length > 0) {
        if (props.partyDetails?.counterpartyOrganizationId) {
          const payload: Record<string, unknown> = {
            counterpartyOrganizationId: props.partyDetails.counterpartyOrganizationId,
            organizationName: orgName.trim(),
            partyType: form?.partyType?.value,
          };
          if (contactName.trim()) payload.contactPersonName = contactName.trim();
          if (phoneEdit.trim()) payload.phone = phoneEdit.trim();
          const g = gstEdit.trim().toUpperCase();
          if (g) payload.gst = g.toLowerCase();
          if (resellerSharingOn) {
            const limit = Math.round(Number(forwardLimit));
            if (isReseller && (!Number.isFinite(limit) || limit < 1 || limit > 50)) {
              notifications({
                title: "Client shares",
                message: "Client shares must be between 1 and 50.",
                type: "warning",
              });
              return;
            }
            payload.isReseller = isReseller;
            if (isReseller) {
              payload.resellerForwardLimit = limit;
              payload.resellerAllowDownload = allowDownload;
            }
          }
          props.updateParty(payload, (res: any) => {
            getAllData(res);
            if (res.success) {
              notifications({
                title: "Success!",
                message: res?.message,
                type: "success",
              });
              gstOptions = [];
              setForm({
                partyName: "",
                partyType: "",
              });
              closeModal();
            } else {
              notifications({
                title: "Error!",
                message: res?.message,
                type: "danger",
              });
            }
          });
        } else {
          let payload = {
            id: props.partyDetails?.id,
            gst:
              form?.partyName?.value?.gst?.length > 0
                ? form?.partyName?.value?.gst?.toLowerCase()
                : "",
            phoneNumber:
              form?.partyName?.value?.phone?.length > 0
                ? ""
                : form?.partyName?.value?.phone,
            partyType: form?.partyType?.value,
          };
          props.updateParty(payload, (res: any) => {
            getAllData(res);
            if (res.success) {
              notifications({
                title: "Success!",
                message: res?.message,
                type: "success",
              });
              gstOptions = [];
              setForm({
                partyName: "",
                partyType: "",
              });
              closeModal();
            } else {
              notifications({
                title: "Error!",
                message: res?.message,
                type: "danger",
              });
            }
          });
        }
      } else {
        let payload = {
          gst:
            form?.partyName?.value?.gst?.length > 0
              ? form?.partyName?.value?.gst?.toLowerCase()
              : "",
          phoneNumber:
            form?.partyName?.value?.gst?.length > 0
              ? ""
              : form?.partyName?.value?.phone,
          partyType: form?.partyType?.value,
        };
        props.connectOrg(payload, (res: any) => {
          getAllData(res);
          if (res.success) {
            notifications({
              title: "Success!",
              message: res?.message,
              type: "success",
            });
            gstOptions = [];
            setForm({
              partyName: "",
              partyType: "",
            });
            closeModal();
          } else {
            notifications({
              title: "Error!",
              message: res?.message,
              type: "danger",
            });
          }
        });
      }
    }
  };
  const handleCloseModal = () => {
    closeModal();
    setForm({ partyName: "", partyType: "" });
  };
  const handleOpenOrg = () => {
    setModalOrg(true);
  };
  const handleGstOptions = (data: any) => {
    setForm({
      ...form,
      partyName: data,
    });
  };
  const handleCloseOrg = () => {
    setModalOrg(false);
  };
  return (
    <>
      <Modal
        isOpen={openModalOrg}
        toggle={handleCloseOrg}
        size="lg"
        className="OrganizationModal"
        fade={false}
      >
        <ModalHeader toggle={handleCloseOrg}>
          <div className="Heading">
            <h3>{"Add New Organization"}</h3>
            <button
              type="button"
              className="modal-close-hit"
              aria-label="Close"
              onClick={handleCloseOrg}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 9 9"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8 1L1 8"
                  stroke="#C59C6C"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1 1L8 8"
                  stroke="#C59C6C"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </ModalHeader>
        <ModalBody>
          <AddOrEditOrganisation
            {...props}
            closeModal={handleCloseOrg}
            // editData={editData}
            getAllData={getAllData}
            name="addParty"
            handleGstOptions={handleGstOptions}
          />
        </ModalBody>
      </Modal>
      <Modal
        isOpen={openModal}
        toggle={closeModal}
        size="lg"
        className="ArtFormModal partyModal"
        fade={false}
      >
        <ModalHeader toggle={handleCloseModal}>
          <div className="Heading">
            <h3>{props.partyDetails?.counterpartyOrganizationId ? "Edit party" : "Add Party"}</h3>
            <ModalCloseIcon closeModal={handleCloseModal} />
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="AddArtform">
            <div className="form">
              {loading ? (
                <div className="LoaderDivModal">
                  <Loader />
                </div>
              ) : (
                <>
                  {props.partyDetails?.counterpartyOrganizationId ? (
                    <>
                      <div className="formDiv">
                        <Label>
                          Organization / display name<span>*</span>
                        </Label>
                        <Input
                          type="text"
                          value={orgName}
                          onChange={(e) => setOrgName(e.target.value)}
                          placeholder="Business or party name shown in /party"
                        />
                        {Error.organizationName ? (
                          <p className="RequiredField">{Error.organizationName}</p>
                        ) : null}
                      </div>
                      <div className="formDiv">
                        <Label>Contact person</Label>
                        <Input
                          type="text"
                          value={contactName}
                          onChange={(e) => setContactName(e.target.value)}
                          placeholder="Person name (optional)"
                        />
                      </div>
                      <div className="formDiv">
                        <Label>
                          Phone<span>*</span>
                        </Label>
                        <Input
                          type="text"
                          value={phoneEdit}
                          onChange={(e) => setPhoneEdit(e.target.value)}
                          placeholder="Registered mobile"
                        />
                        {Error.phoneEdit ? (
                          <p className="RequiredField">{Error.phoneEdit}</p>
                        ) : null}
                      </div>
                      <div className="formDiv">
                        <Label>GST (optional)</Label>
                        <Input
                          type="text"
                          value={gstEdit}
                          onChange={(e) => setGstEdit(e.target.value)}
                          placeholder="15-character GSTIN"
                        />
                        {Error.gstEdit ? <p className="RequiredField">{Error.gstEdit}</p> : null}
                      </div>
                      <div className="formDiv">
                        <Label>
                          Party Type<span>*</span>
                        </Label>
                        <Select
                          className="selector_selector text-white w-100"
                          classNamePrefix="react-select"
                          placeholder="Select party type"
                          value={form?.partyType}
                          options={partyOptions}
                          onChange={(e: any) => {
                            handleChange({
                              name: "partyType",
                              value: e,
                            });
                          }}
                        />
                        {Error.partyType && !form?.partyType ? (
                          <p className="RequiredField">{Error?.partyType}</p>
                        ) : null}
                      </div>
                      {resellerSharingOn ? (
                        <div className="formDiv">
                          <Label className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
                            <input
                              type="checkbox"
                              checked={isReseller}
                              onChange={(e) => setIsReseller(e.target.checked)}
                            />
                            Reseller — can forward catalogues to their own clients
                          </Label>
                          {isReseller ? (
                            <div className="d-flex flex-wrap gap-3 mt-2">
                              <div>
                                <Label for="party-forward-limit">Client shares per catalogue link</Label>
                                <Input
                                  id="party-forward-limit"
                                  type="number"
                                  inputMode="numeric"
                                  min={1}
                                  max={50}
                                  value={forwardLimit}
                                  onChange={(e) => setForwardLimit(e.target.value)}
                                  style={{ maxWidth: "8rem" }}
                                />
                              </div>
                              <Label className="d-flex align-items-center gap-2 mt-4" style={{ cursor: "pointer" }}>
                                <input
                                  type="checkbox"
                                  checked={allowDownload}
                                  onChange={(e) => setAllowDownload(e.target.checked)}
                                />
                                Allow photo downloads
                              </Label>
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                    </>
                  ) : (
                    <>
                      <div className="formDiv">
                        <Label>
                          Party Type<span>*</span>
                        </Label>
                        <div className="formDivSub">
                          <Select
                            className="selector_selector text-white w-100"
                            classNamePrefix="react-select"
                            placeholder="Filter with Gst No. & phone no."
                            value={form?.partyName}
                            options={gstOptionsData}
                            onChange={(e: any) => {
                              handleChange({
                                name: "partyName",
                                value: e,
                              });
                            }}
                            onInputChange={(e) => {
                              if (regexpForGst.test(e)) {
                                handleOnInputChangeFilters({
                                  name: "gst",
                                  value: e.trim(),
                                });
                              } else {
                                handleOnInputChangeFilters({
                                  name: "phone",
                                  value: e,
                                });
                              }
                            }}
                          />
                          <div className="DivSep"></div>
                          <div className="formAddDiv">
                            <AddIcon openModal={handleOpenOrg} />
                          </div>
                        </div>

                        {Error.partyName && !form?.partyName ? (
                          <p className="RequiredField">{Error?.partyName} </p>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="formDiv">
                        <Select
                          className="selector_selector text-white w-100"
                          classNamePrefix="react-select"
                          placeholder="Select party type"
                          value={form?.partyType}
                          options={partyOptions}
                          onChange={(e: any) => {
                            handleChange({
                              name: "partyType",
                              value: e,
                            });
                          }}
                        />
                        {Error.partyType && !form?.partyType ? (
                          <p className="RequiredField">{Error?.partyType} </p>
                        ) : (
                          ""
                        )}
                      </div>
                    </>
                  )}
                </>
              )}
              <Button className="artButton" onClick={() => handleSubmit()}>
                {loading
                  ? "Processing"
                  : props.partyDetails?.counterpartyOrganizationId
                    ? "Update party"
                    : "Add Party"}
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    ...state,
  };
};
export default connect(mapStateToProps, {
  connectOrg,
  updateParty,
})(AddParty);
